import { PasswordValidationResult } from './types';
import { ALLOWED_PASSWORD_SYMBOLS, PASSWORD_MIN_LENGTH, createPasswordSymbolPattern } from '../../../../../shared/constants/password';

export const validatePassword = (password: string): PasswordValidationResult => {
  const minLength = password.length >= PASSWORD_MIN_LENGTH;
  const hasLowerCase = /[a-z]/.test(password);
  const hasUpperCase = /[A-Z]/.test(password);
  const hasNumber = /\d/.test(password);
  const hasSymbol = new RegExp(createPasswordSymbolPattern()).test(password);
  
  return {
    minLength,
    hasLowerCase,
    hasUpperCase,
    hasNumber,
    hasSymbol,
    isValid: minLength && hasLowerCase && hasUpperCase && hasNumber && hasSymbol
  };
};

export const getUserRoleLabel = (role: string): string => {
  switch (role) {
    case 'admin':
      return '管理者';
    case 'student':
      return '一般ユーザー';
    default:
      return '不明';
  }
};

export const getUserStatusColor = (status: string): 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' => {
  switch (status) {
    case 'active':
      return 'success';
    case 'inactive':
      return 'warning';
    case 'suspended':
      return 'error';
    default:
      return 'default';
  }
};

export const getUserStatusLabel = (status: string): string => {
  switch (status) {
    case 'active':
      return 'アクティブ';
    case 'inactive':
      return '非アクティブ';
    case 'suspended':
      return '利用停止';
    default:
      return '不明';
  }
};

// 統合されたユーザー状態表示（status + isVerified を組み合わせ）
export const getIntegratedUserStatus = (status: string, isVerified: boolean): {
  label: string;
  color: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  description: string;
} => {
  if (status === 'suspended') {
    return {
      label: '利用停止',
      color: 'error',
      description: 'アカウントが利用停止されています'
    };
  }
  
  if (status === 'inactive') {
    return {
      label: '非アクティブ',
      color: 'warning',
      description: 'アカウントが非アクティブ状態です'
    };
  }
  
  // status === 'active' の場合
  if (!isVerified) {
    return {
      label: 'メール認証待ち',
      color: 'warning',
      description: 'メールアドレスの認証が完了していません'
    };
  }
  
  return {
    label: 'アクティブ',
    color: 'success',
    description: 'アカウントが正常に利用可能です'
  };
};

// disabled状態のTextFieldのスタイル
export const disabledTextFieldStyles = {
  '& .MuiOutlinedInput-root.Mui-disabled': {
    cursor: 'default',
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
    },
    '& .MuiOutlinedInput-input': {
      cursor: 'default',
    },
  },
}; 